/* eslint-disable no-undef */
const config = {
	...process.env,
	...import.meta.env,
	API_URL: import.meta.env.VITE_API_URL,
};

export default config;
